export function ignoreUndoRedoHotkey(event: KeyboardEvent): boolean {
  const target = event.target as HTMLElement | null;
  if (!target?.tagName) {
    return false;
  }

  const tagName = target.tagName.toUpperCase();
  if (tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT') {
    return true;
  }

  return target.isContentEditable;
}
